module.exports = __webpack_public_path__ + "static/media/banner_header_navidad.c5e045dd.svg";